<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">桌费分润比例修改</el-breadcrumb-item>
        </el-breadcrumb>
        <el-radio-group v-model="tabPosition"  style="margin-bottom: 30px;">
            <el-radio-button label="1">修改一级代理</el-radio-button>
            <el-radio-button label="2">修改二级代理</el-radio-button>
        </el-radio-group>
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="一级代理商" >
                <el-select v-model="formInline.bindDistributorId" @change="FirstLevelAgentChange" placeholder="请选择">
                    <el-option
                    v-for="item in FirstLevelAgentOptions"
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级代理商" v-if="formInline.bindDistributorId != '' && tabPosition == 2">
                <el-select v-model="formInline.secDistributorId" @change="SecondaryAgentChange" placeholder="请选择">
                    <el-option
                    v-for="item in SecondaryAgentOptiens"
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <!-- <el-button size="small" @click="empty">重置</el-button> -->
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <el-button size="small" :disabled="submitFlag" type="primary" @click="submitClick">提交保存</el-button>
        <div class="content">
            <div class="editScale">
                <div class="editScale_title">
                    批量修改一级代理商比例
                </div>
                <el-input placeholder="比例" style="width:150px" :disabled="tabPosition == '2'" @focus="terraceScalefocus" @blur="terraceScaleBlur" @change="distributorDivisionChange" v-model="inputValue01">
                    <template slot="append">%</template>
                </el-input>
                <div class="editScale_title" style="width:150px">
                    批量修改二级代理商
                </div>
                <el-input placeholder="比例" style="width:150px" @focus="terraceScalefocus" @blur="terraceScaleBlur" @change="secDistributorDivisionChange" v-model="inputValue02">
                    <template slot="append">%</template>
                </el-input>
                <div class="editScale_title">
                    批量修改商家比例
                </div>
                <el-input placeholder="比例" style="width:150px" @focus="terraceScalefocus" @blur="terraceScaleBlur" @change="businessDivisionChange" v-model="inputValue03">
                    <template slot="append">%</template>
                </el-input>
            </div>
            <div v-for="item in editScaleList" :key="item.id">
                <div class="editScale" >
                    <div class="editScale_title">
                        一级代理商：{{item.distributorName}}
                    </div>
                    <el-input placeholder="比例" style="width:150px" disabled v-model="item.distributorDivision">
                        <template slot="append">%</template>
                    </el-input>
                    <div class="editScale_title">
                        二级代理商:{{item.secDistributorName}}
                    </div>
                    <el-input placeholder="比例" style="width:150px" @focus="terraceScalefocus" @blur="secDistributorBlur(item)" v-model="item.secDistributorDivision">
                        <template slot="append">%</template>
                    </el-input>
                    <div class="editScale_title">
                        商家:{{ item.businessName }}
                    </div>
                    <el-input placeholder="比例" style="width:150px" v-model="item.businessDivision">
                        <template slot="append">%</template>
                    </el-input>
                </div>
                <div class="editScale_msg" v-if="item.msg != ''">{{item.msg}}</div>
            </div>
        </div>
</div>
</template>
<script>
import { storeSelect , divisionList , divisionUpdate} from '../../api/userMG'
export default {
    data(){
        return{
            FirstLevelAgentOptions:[],
            SecondaryAgentOptiens:[],
            BusinessUserOptions:[],
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
                machineId:'',
                bindDistributorId:'',
                secDistributorId:'',
                bindStoreId:''
            },
            tabPosition:'1',
            editScaleList:[],
            submitFlag:false,
            inputValue01:'',
            inputValue02:'',
            inputValue03:'',
        }
    },
    components: {
        
    },
    created(){
        this.storeSelect()
    },
    methods:{
        terraceScalefocus(){
            this.submitFlag = true
        },
        terraceScaleBlur(){
            this.submitFlag = false
        },
        secDistributorBlur(e){
            let data = JSON.parse(JSON.stringify(this.editScaleList))
            for(let item of data){
                if(e.secDistributorId == item.secDistributorId){
                    item.secDistributorDivision = e.secDistributorDivision
                }
            }
            this.editScaleList = data
            this.submitFlag = false
        },
        submitClick(){
            if(this.editScaleList.length == 0)return
            var regExp = new RegExp('^\\d{1,10}([.]\\d{1,2})?$');
            var reg = /^([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
            let data = JSON.parse(JSON.stringify(this.editScaleList))
            let dataFlag =  true
            for(let item of data){
                if(!reg.test(item.businessDivision)){
                    console.log("0001")
                    item.msg = '商家分成比例格式错误'
                    dataFlag = false
                }else if(reg.test(item.businessDivision) && !regExp.test(item.businessDivision)){
                    item.msg = '商家小数点保留两位'
                    console.log("0002")
                    dataFlag = false
                }else if (item.businessDivision > 100) {
                    console.log("0003")
                    item.msg = '商家分成比例不能大于100'
                    dataFlag = false
                }else if(!reg.test(item.secDistributorDivision)){
                    console.log("0004")
                    item.msg = '二级代理分成比例格式错误'
                    dataFlag = false
                }else if(reg.test(item.secDistributorDivision) && !regExp.test(item.secDistributorDivision)){
                    item.msg = '二级代理小数点保留两位'
                    console.log("0005")
                    dataFlag = false
                }else if (item.secDistributorDivision > 100) {
                    console.log("0006")
                    item.msg = '二级代理分成比例不能大于100'
                    dataFlag = false
                }else if(!reg.test(item.distributorDivision)){
                    console.log("0007")
                    item.msg = '一级代理分成比例格式错误'
                    dataFlag = false
                }else if(reg.test(item.distributorDivision) && !regExp.test(item.distributorDivision)){
                    item.msg = '一级代理小数点保留两位'
                    console.log("0008")
                    dataFlag = false
                }else if (item.distributorDivision > 100) {
                    console.log("0009")
                    item.msg = '一级代理分成比例不能大于100'
                    dataFlag = false
                }else if (item.distributorDivision < item.secDistributorDivision) {
                    console.log("00010")
                    item.msg = '二级代理分润比例不能大于一级代理'
                    dataFlag = false
                }else if (item.secDistributorDivision < item.businessDivision) {
                    console.log("00010")
                    item.msg = '商家分润比例不能大于二级代理'
                    dataFlag = false
                }else {
                    item.msg = ''
                }
            }
            if(dataFlag){
                this.$message.success('通过')
                divisionUpdate(data).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('修改成功')
                        this.seditScaleList = data
                    }
                })
            }else {
                this.editScaleList = data
            }
        },
        distributorDivisionChange(e){
            this.submitFlag = false
            var regExp = new RegExp('^\\d{1,10}([.]\\d{1,2})?$');
            var reg = /^([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
            if(!reg.test(e)){
                this.$message.error('分成比例格式错误')
            }else if(reg.test(e) && !regExp.test(e)){
                this.$message.error('小数点保留两位')
            }else if(e > 100) {
                this.$message.error('分成比例不能大于100')
            }else {
                let data = this.editScaleList
                for(let item of data){
                    item.distributorDivision = e
                }
                this.editScaleList = data
            }
        },
        secDistributorDivisionChange(e){
            this.submitFlag = false
            var regExp = new RegExp('^\\d{1,10}([.]\\d{1,2})?$');
            var reg = /^([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
            if(!reg.test(e)){
                this.$message.error('分成比例格式错误')
            }else if(reg.test(e) && !regExp.test(e)){
                this.$message.error('小数点保留两位')
            }else if(e > 100) {
                this.$message.error('分成比例不能大于100')
            }else {
                let data = this.editScaleList
                for(let item of data){
                    item.secDistributorDivision = e
                }
                this.editScaleList = data
            }
        },
        businessDivisionChange(e){
            this.submitFlag = false
            var regExp = new RegExp('^\\d{1,10}([.]\\d{1,2})?$');
            var reg = /^([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
            if(!reg.test(e)){
                this.$message.error('分成比例格式错误')
            }else if(reg.test(e) && !regExp.test(e)){
                this.$message.error('小数点保留两位')
            }else if(e > 100) {
                this.$message.error('分成比例不能大于100')
            }else {
                let data = this.editScaleList
                for(let item of data){
                    item.businessDivision = e
                }
                this.editScaleList = data
            }
        },
        search(){
            if(this.tabPosition == 1){
                if(this.formInline.bindDistributorId == ''){
                    this.$message.error('请选择一级代理')
                }else{
                    this.divisionList({distributorId:this.formInline.bindDistributorId})
                }
            }else {
                if(this.formInline.secDistributorId == ''){
                    this.$message.error('请选择二级代理')
                }else {
                    this.divisionList({secDistributorId :this.formInline.secDistributorId})
                }
            }
        },
        divisionList(data){
            divisionList(data).then(res=>{
                this.editScaleList = res.data
            })
        },
        SecondaryAgentChange(e){
            if(e == ''){
                this.formInline.bindStoreId = ''
            }else {
                loadBusinessUserList({
                    page:1,
                    pageSize:500,
                    secDistributorId:e
                }).then(res=>{
                    data = data.concat(res.pageInfo.list)
                    this.BusinessUserOptions = data
                })
            }
        },
        FirstLevelAgentChange(e){
            console.log(e)
            if(e == ''){
                this.formInline.secDistributorId = ''
                this.formInline.bindStoreId = ''
            }else {
                storeSelect({
                    pageSize:500,
                    page:1,
                    userType:2,
                    parentId:e
                }).then(res=>{
                    let data = []
                    data = data.concat(res.data.dataList)
                    this.SecondaryAgentOptiens = data
                })
            }
        },
        storeSelect(){
            storeSelect({
                pageSize:500,
                page:1,
                userType:1,
            }).then(res=>{
                let data = []
                data = data.concat(res.data.dataList)
                this.FirstLevelAgentOptions = data
            })
        },
    }
}
</script>
<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .editScale{
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    line-height: 40px;
    margin-bottom: 20px;
  }
  .editScale_title{
    width: 200px;
    text-align: center;
  }
  .editScale_msg{
    padding-left: 30px ;
    margin-bottom: 20px;
    color: red;
  }
  .content{
    width: 1200px;
    max-height: 600px;
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/DividendModification.vue